import React, { useState, useEffect, useContext } from "react";
import { TablePaginationConfig, Table, Checkbox } from "antdv5";
import { Spin } from "antdv5";
import DefaultLayout from "components/layout/DefaultLayout";
import Container from "components/common/Container";
import ClubOpts from "components/common/ClubOpts";
import useAPI from "components/customHook/useApi";
import TimeSelector from "components/common/TimeSelector";
import day from "dayjs";
import { TableOutter, StyledDiv } from "../styles/TrainRecord";
import { context } from "components/context/Context";

const initialState = {
  data: [],
  totalPage: null,
};

const TrainRecord = () => {
  const { state } = useContext(context);
  const [trainRecord, setTrainRecord] = useState<{
    data: any;
    totalPage: null | number;
  }>(initialState);
  const {
    loading: spinLoading,
    preventRefreshCount,
    handleAuth,
    clubList,
  } = useAPI();
  const [loading, setLoading] = useState(false);
  const [isClear, setIsClear] = useState(true);
  const [establishedDate, setEstablishedDate] = useState<string[]>([]);
  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([
    null,
    null,
  ]);
  const [startDate, endDate] = dateRange;
  const columns = [
    {
      title: "序号",
      dataIndex: "rank",
      width: 100,
    },
    {
      title: "记录编号",
      dataIndex: "ActionID",
      width: 200,
      textWrap: "word-break",
    },
    {
      title: "当前设定",
      dataIndex: "Actived",
      width: 100,
      render: (text: string, record: { Actived: string }) => (
        <StyledDiv actived={record.Actived === "1" ? true : false}>
          {record.Actived === "1" ? "处理中" : "无"}
        </StyledDiv>
      ),
    },
    {
      title: "操作",
      dataIndex: "",
      width: 60,
      render: (
        text: { Date: string; ActionID: string },
        record: { Actived: string }
      ) =>
        record.Actived === "0" ? null : ( // <div className='settingBtn' key='edit' onClick={()=>handleConfig(record)}>设定</div>
          <button className="clearBtn" onClick={() => handleClear(text)}>
            清零
          </button>
        ),
    },
    {
      title: "建立时间",
      dataIndex: "Date",
      width: 200,
      render: (text: string) => <div>{text.replace(/T/g, " ")}</div>,
    },
    {
      title: "更新时间",
      dataIndex: "Updated",
      width: 200,
      render: (text: string) => <div>{text.replace(/T/g, " ")}</div>,
    },
    {
      title: "编辑",
      dataIndex: "",
      width: 100,
      render: (text: { ActionID: string }, record: { Actived: string }) =>
        record.Actived === "0" ? (
          <button
            className="btn delSingle"
            onClick={() => handleDelete(text.ActionID)}
          >
            删除
          </button>
        ) : null,
    },
  ];
  const fetchTrainRecord = () => {
    setLoading(true);
    if (
      localStorage.getItem("onAuth") === "true" &&
      localStorage.getItem("gid") !== ""
    ) {
      fetch(
        `${
          process.env.REACT_APP_API_URL
        }ApiGetJsonDeviceActionidList.ashx?Gid=${localStorage.getItem("gid")}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json; charset=utf-8",
            Authorization: localStorage.getItem("token") || "",
          },
        }
      )
        .then((res) => res.json())
        .then((res) => {
          if (res.Data !== null && res.Data.length !== 0) {
            let result = [...res.Data];
            for (let i = 0; i < res.Data.length; i++) {
              result[i] = { ...res.Data[i], rank: i + 1 };
            }
            setTrainRecord({
              data: result,
              totalPage: result[0].TotalCount,
            });
            let allDate: string[] = [];
            res.Data.forEach((elem: { Date: string }) => {
              allDate.push(elem.Date.replace(/T/g, " "));
            });
            setEstablishedDate(allDate);
            setLoading(false);
          } else {
            setTrainRecord(initialState);
            setLoading(false);
          }
        });
    } else {
      setLoading(false);
    }
  };
  const fetchNewRecord = (pageSize: number, nowPage: number) => {
    setLoading(true);
    if (
      localStorage.getItem("onAuth") === "true" &&
      localStorage.getItem("gid") !== ""
    ) {
      fetch(
        `${
          process.env.REACT_APP_API_URL
        }ApiGetJsonDeviceActionidList.ashx?Gid=${localStorage.getItem(
          "gid"
        )}&PageSize=${pageSize}&NowPage=${nowPage}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json; charset=utf-8",
            Authorization: localStorage.getItem("token") || "",
          },
        }
      )
        .then((res) => res.json())
        .then((res) => {
          if (res.Data !== null && res.Data.length !== 0) {
            let result = [...res.Data];
            for (let i = 0; i < res.Data.length; i++)
              result[i] = { ...res.Data[i], rank: (nowPage - 1) * 20 + 1 + i };
            setTrainRecord({
              ...trainRecord,
              data: result,
            });
          }
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  };
  const handleClear = (text: { Date: string; ActionID: string }) => {
    const nowY = new Date().getFullYear();
    const nowM =
      Number(new Date().getMonth() + 1) < 10
        ? "0" + Number(new Date().getMonth() + 1)
        : Number(new Date().getMonth() + 1);
    const nowD =
      Number(new Date().getDate()) < 10
        ? "0" + new Date().getDate()
        : Number(new Date().getDate());
    const nowDate = nowY + "-" + nowM + "-" + nowD;
    const estY = new Date(text.Date).getFullYear();
    const estM =
      Number(new Date(text.Date).getMonth() + 1) < 10
        ? "0" + Number(new Date(text.Date).getMonth() + 1)
        : Number(new Date(text.Date).getMonth() + 1);
    const estD =
      Number(new Date(text.Date).getDate()) < 10
        ? "0" + new Date(text.Date).getDate()
        : Number(new Date(text.Date).getDate());
    const establishDate = estY + "-" + estM + "-" + estD;
    // const nowDate = Intl.DateTimeFormat('zh-CN',{
    //   year:'numeric',
    //   month:'2-digit',
    //   day:'2-digit',
    // }).format(new Date()).replace(/\//g, '-')
    // const establishDate = Intl.DateTimeFormat('zh-CN',{
    //   year:'numeric',
    //   month:'2-digit',
    //   day:'2-digit',
    // }).format(new Date(text.Date)).replace(/\//g,'-')
    if (window.confirm("是否清零每日归返中的今日数据？")) {
      if (nowDate === establishDate) {
        fetch(
          `${process.env.REACT_APP_API_URL}ApiPostJsonActionIDClearCreateDayData.ashx`,
          {
            method: "POST",
            headers: {
              Authorization: localStorage.getItem("token") || "",
              "Content-Type": "application/json; charset=utf-8",
            },
            body: JSON.stringify({
              Gid: localStorage.getItem("gid"),
              Uid: text.ActionID,
            }),
          }
        );
        alert("清零成功");
      } else {
        alert("只能清零当日数据");
        return;
      }
    }
  };
  const handleDelete = async (
    text = "",
    startDate: Date | string = "",
    endDate: Date | string = ""
  ) => {
    const start = day(startDate).format("YYYY-MM-DD");
    const end = day(endDate).format("YYYY-MM-DD");
    // console.log('text',text,'s', start,'e', end)
    if (window.confirm("确认删除扫描记录？")) {
      const fetchData = await fetch(
        `${process.env.REACT_APP_API_URL}ApiPostJsonRecordActionID_Delete.ashx`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json; charset=utf-8",
            Authorization: localStorage.getItem("token") || "",
          },
          body: JSON.stringify({
            Gid: localStorage.getItem("gid"),
            Aid: text,
            StartDay: start,
            EndDay: end,
          }),
        }
      );
      const parsedData = await fetchData.json();
      if (parsedData.InfoGet[0].Status === "Success") {
        alert("删除成功");
      } else {
        alert(parsedData.InfoGet[0].Status);
      }
    } else {
      return;
    }
  };

  const handleActionID = () => {
    let result = window.confirm(`产生新的踏板扫描记录？`);
    if (result === true && localStorage.getItem("onAuth") === "true") {
      const nowDay = new Date();
      const nowMonth =
        Number(nowDay.getMonth()) + 1 < 10
          ? "0" + (Number(nowDay.getMonth()) + 1)
          : Number(nowDay.getMonth()) + 1;
      const nowDate =
        Number(nowDay.getDate()) < 10
          ? "0" + Number(nowDay.getDate())
          : Number(nowDay.getDate());
      let isToday = nowDay.getFullYear() + "-" + nowMonth + "-" + nowDate;

      let checkIsToday = establishedDate.find(
        (e: string) => e.split(" ")[0] === isToday
      );
      if (checkIsToday === undefined) {
        setLoading(true);
        fetch(
          `${process.env.REACT_APP_API_URL}ApiPostJsonDeviceActionid_Add.ashx`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json; charset=utf-8",
              Authorization: localStorage.getItem("token") || "",
            },
            body: JSON.stringify({
              Gid: localStorage.getItem("gid"),
              Clear: isClear,
            }),
          }
        )
          .then((res) => res.json())
          .then((res) => {
            fetchTrainRecord();
            setLoading(false);
          });
      } else {
        if (window.confirm("今日已产生过扫描记录，是否确定在此产生？")) {
          fetch(
            `${process.env.REACT_APP_API_URL}ApiPostJsonDeviceActionid_Add.ashx`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json; charset=utf-8",
                Authorization: localStorage.getItem("token") || "",
              },
              body: JSON.stringify({
                Gid: localStorage.getItem("gid"),
                Clear: isClear,
              }),
            }
          )
            .then((res) => res.json())
            .then((res) => {
              fetchTrainRecord();
              setLoading(false);
            });
        } else {
          return;
        }
      }
    } else {
      return false;
    }
  };
  const handleChange = (pagination: TablePaginationConfig) => {
    fetchNewRecord(pagination.pageSize || 100, pagination.current || 1);
  };
  useEffect(() => {
    if (localStorage.getItem("onAuth") === "true") {
      preventRefreshCount(fetchTrainRecord, 5);
    }
  }, [state?.gid]);
  useEffect(() => {
    handleAuth();
  }, [trainRecord, state?.gid]);
  return (
    <DefaultLayout>
      <Container>
        <Spin spinning={spinLoading} tip={"请等候3秒"}>
          <TableOutter>
            <div className="box">
              <span className="scanBtn">
                <button className="btn" onClick={handleActionID}>
                  产生新的踏板扫描
                </button>
                <Checkbox
                  checked={isClear}
                  onChange={() => setIsClear(!isClear)}
                >
                  同时清零每日归返中的今日数据 (包含所有记录编号的今日数据)
                </Checkbox>
              </span>
              <ClubOpts clubList={clubList} />
            </div>
            <div className="deleteDateRange">
              <div className="selector">
                <TimeSelector
                  setDateRange={setDateRange}
                  startDate={startDate}
                  endDate={endDate}
                />
              </div>
              <button
                className="btn delRange"
                disabled={startDate === null || endDate === null}
                onClick={() =>
                  handleDelete("", startDate || undefined, endDate || undefined)
                }
              >
                删除区间
              </button>
            </div>
            <Table
              className="bordered-table-no-white-border"
              columns={columns}
              dataSource={trainRecord.data}
              pagination={{
                defaultPageSize: 20,
                total: trainRecord.totalPage || undefined,
                showTotal: (total, range) =>
                  `${range[0]}-${range[1]} / ${total} 笔`,
                showQuickJumper: true,
              }}
              onChange={handleChange}
              size={"small"}
              scroll={{ x: "max-content" }}
              rowKey="ActionID"
              loading={loading}
              bordered
            />
          </TableOutter>
        </Spin>
      </Container>
    </DefaultLayout>
  );
};

export default TrainRecord;
